import Vue from 'vue'
import VueRouter from 'vue-router'
import Reservation from '../views/Reservation.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'reservation',
    component: Reservation
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: Reservation
  }
]

const router = new VueRouter({
  routes
})

export default router
